import { modificationQueryKeys as e } from "./useModificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { bookingsApi as n } from "@maat/api-booking";
//#region src/modifications/useBookingModificationsQuery.ts
var r = (r, i) => t({
	queryKey: e.list(r),
	queryFn: () => n.listBookingModifications(r),
	enabled: i?.enabled ?? !0
});
//#endregion
export { r as useBookingModificationsQuery };
